<template>
  <div class="row">
    <div class="col-md-12">
      <progress-bar></progress-bar>
      <transition name="view" appear enter-active-class="animated flipInX delay">
        <new-articles v-if="dataShown" :project-id="currentProject" :show-save="this.dataShown" :order="lastOrder" @add-new="add" @save="save"></new-articles>
      </transition>
    </div>
    <div class="col-md-12">
      <transition v-if="dataShown" name="view" appear enter-active-class="animated slideInUp" leave-active-class="animated slideOutDown delay2">
        <existing-articles :articles="articles" :project-id="currentProject"></existing-articles>
      </transition>
    </div>
  </div>
</template>

<script>
    import axios from "axios";
    import {setCookie, url} from "../plugins/axios";
    import NotificationTemplate from "./Notifications/NotificationTemplate";
    import ExistingArticles from "./IncomesExpensesSettings/ExistingArticles";
    import NewArticles from "./IncomesExpensesSettings/NewArticles";
    import ProgressBar from "../components/Progress";
    export default {
      name: "incomes-expenses-settings",
      components: {ProgressBar, NewArticles, ExistingArticles},
      data(){
        return{
          currentProject: 0,
          projectName: '',
          articles: [],
          articlesOld: [],
          dataShown: false,
          lastOrder: 0,
        }
      },
      methods:{
        notifyVue(type,message) {
          this.$notify({
            component: NotificationTemplate,
            icon: "tim-icons icon-bell-55",
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: type,
            message:message,
            timeout: 1500
          });
        },
        getArticles(id){
          axios
            .get(url + 'articles/' + id + '/',
              {
                withCredentials:'include',
                crossDomain:true
              })
            .then((response) => {
              if (response.data.error === ''){
                this.articles = response.data.result;
                if(this.articles !== null){
                  for(let article in this.articles){
                    this.articles[article]["is_expense"] = (this.articles[article]["is_expense"] == 1) ? "True" : "False";
                  }
                  this.lastOrder = this.getOrder(this.articles);
                  this.articlesOld = JSON.parse(JSON.stringify(this.articles));
                  this.dataShown = true;
                }
              }
              else{
                if (response.data.error === 'Session is over'){
                  setCookie('Authentication','Failed',1);
                  this.$router.push('/');
                }
                else{
                  this.notifyVue('danger',response.data.error);
                }
              }
            })
            .catch((error) => {
              this.notifyVue('danger',error);
            });
        },
        add(item){
          axios
            .post(url + 'add-articles/',
              {data: item},
              {
                withCredentials:'include',
                crossDomain:true
              }
            )
            .then((response) => {
              if (response.data.error === ''){
                this.notifyVue('success','Item was added');
                this.getArticles(this.currentProject);
                this.articlesOld = JSON.parse(JSON.stringify(this.articles));
              }
              else{
                if (response.data.error === 'Session is over'){
                  setCookie('Authentication','Failed',1);
                  this.$router.push('/login');
                }
                else{
                  this.notifyVue('danger',response.data.error);
                }
              }
            })
            .catch((error) => {
              this.notifyVue('danger',error);
            })
        },
        getOrder(articles){
          let lastOrder = 0;
          if (this.currentProject === '3'){lastOrder = parseInt(articles[articles.length-1].office_order);}
          else{lastOrder = parseInt(articles[articles.length-1].others_order);}
          return lastOrder;
        },
        save(){
          if (JSON.stringify(this.articles) !== JSON.stringify(this.articlesOld)){
            const data = this.getDifference(this.articles, this.articlesOld);
            for(let article in data){
              data[article]["is_expense"] = (data[article]["is_expense"] === "True") ? "1" : "0";
            }
            axios
              .put(url + 'update-articles/',
                {data: data},
                {
                  withCredentials:'include',
                  crossDomain:true
                })
              .then((response) => {
                if (response.data.error === ''){
                  this.notifyVue('success','Data was updated');
                  this.articlesOld = JSON.parse(JSON.stringify(this.articles));
                }
                else{
                  if (response.data.error === 'Session is over'){
                    setCookie('Authentication','Failed',1);
                    this.$router.push('/login');
                  }
                  else{
                    this.notifyVue('danger',response.data.error);
                  }
                }
              })
          }
          else{
            this.notifyVue('info','Data was updated');
          }
        },
        getDifference(newObj, oldObj){
          let result = '[';
          for(let index in newObj){
            if (JSON.stringify(newObj[index]) !== JSON.stringify(oldObj[index])){
              let newRec = newObj[index];
              let oldRec = oldObj[index];
              result = result + '{' + '"article_id":' + newRec['article_id'] + ',';
              for(let param in newRec){
                if (JSON.stringify(newRec[param]) !== JSON.stringify(oldRec[param])){
                  result = result + '"' + param + '":"' + newRec[param] + '",';
                }
              }
              result = result.substr(0,result.length-1) + '},';
            }
          }
          result = result.substr(0,result.length-1) + ']';
          return JSON.parse(result);
        },
      },
      created() {
        const params = this.$route.query;
        this.currentProject = params.projectId;
        this.projectName = params.projectName.split('_').join(' ');
        if (this.currentProject > 0){
          this.getArticles(this.currentProject);
        }
      }
    }
</script>

<style scoped>
  .delay{
    animation-delay: 1.0s;
  }
  .delay2{
    animation-delay: 3.0s;
  }
</style>
